var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('doalog-slot',{staticClass:"min-dialog-w",attrs:{"show":_vm.settingProductAnalysisShow,"width":"70%","leftText":"取消","title":"查看分析","rightHide":true},on:{"on-close":function($event){return _vm.$emit('on-close')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }